import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    icon: "fa fa-question-circle",
    label: "Support"
  }, _ctx.$attrs, {
    onClick: _ctx.show,
    dense: _ctx.$q.screen.lt.md,
    class: "support-btn"
  }), null, 16, ["onClick", "dense"]))
}